<script lang="ts">
import ItemByCategory from "@/components/Dashboard/Widget/ItemByCategory.vue";
import TotalItem from "@/components/Dashboard/Widget/TotalItem.vue";
import TotalUser from "@/components/Dashboard/Widget/TotalUser.vue";
import TotalVessel from "@/components/Dashboard/Widget/TotalVessel.vue";
import { useDashboardStore } from "@/stores/dashboard/general";
import { isAllowedToShow } from "@/utils/helper";
import { defineComponent, ref } from "vue";
import { db } from "@/database/db";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import RequisitionOverview from "@/components/Dashboard/RequisitionOverview.vue";
import RequisitionChart from "@/components/Dashboard/RequisitionChart.vue";

export default defineComponent({
  name: "GeneralDashboard",
  components: {
    TotalItem,
    TotalUser,
    TotalVessel,
    ItemByCategory,
    BaseLoading,
    RequisitionOverview,
    RequisitionChart,
  },
  setup() {
    const loginInfo = ref();
    const isAdmin = ref(false);
    const storeDashboard = useDashboardStore();
    const generalData = ref();
    const isLoading = ref(true);

    const loadGeneralDashboard = async () => {
      const { success } = await storeDashboard.dispatchGeneral();
      generalData.value = storeDashboard.generalData;
    };

    const loadData = async () => {
      const stringLoginInfo = await db.storage.get("login-info");
      loginInfo.value = stringLoginInfo?.data;
      if (loginInfo.value == null) {
        isAdmin.value = true;
      }
      setTimeout(() => {
        isLoading.value = false;
      }, 1000);
    };

    setTimeout(() => {
      loadData();
    }, 1500);

    loadGeneralDashboard();

    const checkPermission = (permission: any) => {
      return isAllowedToShow(permission);
    };

    return {
      loginInfo,
      isAdmin,
      generalData,
      checkPermission,
      isLoading,
    };
  },
});
</script>
<template>
  <div class="main-content-container overflow-hidden">
    <div class="row">
      <div class="col-md-6">
        <RequisitionOverview />
      </div>
      <div class="col-md-6">
        <RequisitionChart />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-sm-6">
            <TotalUser
              :total="generalData?.user_total?.total"
              v-show="checkPermission('total-user')"
            />
          </div>
          <div class="col-sm-6">
            <TotalItem
              :total="generalData?.item_total?.total"
              v-show="checkPermission('total-item')"
            />
          </div>
          <div class="col-sm-6">
            <TotalVessel
              :total="generalData?.vessel_total?.total"
              v-show="checkPermission('total-vessel')"
            />
          </div>
          <!-- <div class="col-sm-6">
            <TotalItem />
          </div> -->
        </div>
      </div>
      <div class="col-md-4">
        <ItemByCategory />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="!isAdmin">
        <div class="card card-loading bg-white border-0 rounded-3 mb-4">
          <BaseLoading v-if="isLoading" />
          <div class="card-body p-4" v-if="!isLoading">
            <h3 class="mb-3 mb-lg-4">Ship Owner</h3>
            <ul class="ps-0 mb-0 list-unstyled">
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Name:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.ship_owner_company?.name
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="!isAdmin">
        <div class="card card-loading bg-white border-0 rounded-3 mb-4">
          <BaseLoading v-if="isLoading" />
          <div class="card-body p-4" v-if="!isLoading">
            <h3 class="mb-3 mb-lg-4">Ship Management Company</h3>
            <ul class="ps-0 mb-0 list-unstyled">
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Name:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.ship_management_company?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Registration Number:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.ship_management_company?.reg_no
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Country:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.ship_management_company?.country
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card card-loading bg-white border-0 rounded-3 mb-4">
          <BaseLoading v-if="isLoading" />
          <div class="card-body p-4" v-if="!isLoading">
            <h3 class="mb-3 mb-lg-4">Profile Information</h3>
            <ul class="ps-0 mb-0 list-unstyled">
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Username:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.user?.username
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Full Name:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.user?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Phone:</span>
                <span class="text-secondary fw-medium ms-1"
                  >+{{
                    loginInfo?.user?.phone_code + loginInfo?.user?.phone
                  }}</span
                >
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Role:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.role?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Role Group:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.role_group?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Designation:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.job?.name
                }}</span>
              </li>
              <!-- <li class="d-flex align-items-center">
                <span>Join Date:</span>
                <span class="text-secondary fw-medium ms-1"></span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="!isAdmin">
        <div class="card card-loading bg-white border-0 rounded-3 mb-4">
          <BaseLoading v-if="isLoading" />
          <div class="card-body p-4" v-if="!isLoading">
            <h3 class="mb-3 mb-lg-4">Vessel Information</h3>
            <ul class="ps-0 mb-0 list-unstyled">
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Name:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.vessel?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Call Sign:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.vessel?.call_sign
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Class:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.vessel?.vesselClass?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>Type:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.vessel?.vesselType?.name
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>IMO:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.vessel?.imo
                }}</span>
              </li>
              <li class="d-flex align-items-center mb-2 pb-1">
                <span>MMSI:</span>
                <span class="text-secondary fw-medium ms-1">{{
                  loginInfo?.vessel?.mmsi
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.card-loading {
  min-height: 290px;
}
</style>
